export default "__VITE_ASSET__CMiuKhSK__"